import TextAreaMixin from 'trunks/vue/share/components/fields/text_area.js';
import FieldMixinForResponse from './mixin.js';

const TextAreaForResponse = {
  mixins: [
    FieldMixinForResponse,
    TextAreaMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="advance-textarea form-field-value" :readonly="!editing">
          <pre class="textarea-pre">{{ value }}</pre>
          <textarea v-model='value'
                    rows='3'
                    :disabled="!editing"
                    placeholder="请输入"
                    @input.stop.prevent='userInput'
                    ref='input'></textarea>
        </div>
      </template>
    </Field>
  `
};

export default TextAreaForResponse;
